import CantileverTheme from 'styles/cantileverTheme'

export const EditModeColor = CantileverTheme.colors.blue['100']
export const MapBackgroundColor = 'rgb(154, 168, 194)'
